import { render, staticRenderFns } from "./error.vue?vue&type=template&id=158eb7d0&scoped=true"
import script from "./error.vue?vue&type=script&lang=js"
export * from "./error.vue?vue&type=script&lang=js"
import style0 from "./error.vue?vue&type=style&index=0&id=158eb7d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158eb7d0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductSliderListItem: require('/app/components/ProductSliderListItem.vue').default})
